import React, { useContext } from 'react'
import Group from 'components/utils/Group'
import LinePhoneIcon from 'components/Luxkit/Icons/line/LinePhoneIcon'
import TextLink from 'components/Luxkit/TextLink'
import BodyText from 'components/Luxkit/Typography/BodyText'
import Heading from 'components/Luxkit/Typography/Heading'
import LayoutContainer from 'components/Common/LayoutContainer'
import ContactContext from 'contexts/contactContext'

// TODO: refactor (https://aussiecommerce.atlassian.net/browse/CRUZ-2510)
function NeedHelp() {
  const currentContact = useContext(ContactContext)
  const supportContact = currentContact.defaultContact

  return (
    <LayoutContainer>
      <Group gap={0} tabletGap={8} direction="vertical">
        <Heading variant="heading6">
          Need help?
        </Heading>
        <Group direction="vertical" desktopDirection="horizontal" gap="12 0" desktopGap="0 12">
          <BodyText variant="medium" colour="neutral-three">
            Call our customer service team 24 hours, 7 days.
          </BodyText>
          <TextLink
            startIcon={<LinePhoneIcon />}
            size="medium"
            href={`tel:${supportContact.number}`}
          >
            {supportContact.humanReadable}
          </TextLink>
        </Group>
      </Group>
    </LayoutContainer>
  )
}

export default NeedHelp
